import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Cluster({ className, ...rest }) {
    return _jsx("div", { className: cn("fwfa-cluster", className), ...rest });
}
//# sourceMappingURL=Cluster.js.map